import { Link, useNavigate } from '@tanstack/react-location'
import Input from 'MediaManager/components/Form/Input'
import ScreenLayout from 'MediaManager/layouts/ScreenLayout'
import { deleteModel, getModels } from 'MediaManager/services/models'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { toast } from 'react-toastify'
import Button from 'shared/components/Button'
import DataTable from 'shared/components/DataTable'
import Loader from 'shared/components/Loader'
import { objectCopy } from 'shared/helpers/general'
import { useRequest } from 'shared/hooks/useRequest'

function Manage3DModelsScreen(props) {
  const [search, setSearch] = useState('')

  const modelsRequest = useCallback(async () => {
    const { data } = await getModels()
    return data.models
  }, [])

  const table = [
    {
      label: 'ID',
      data: (d) => d.id,
      width: "100px"
    },
    {
      label: 'High resolution model path',
      data: (d) => d.high_res_model_path,
    },
    {
      label: 'Asset Name',
      data: (d) => d.asset?.asset_name || '-',
    },
    {
      label: 'Show unit model in AP/TP',
      data: (d) => (d.show_unit_model_in_apartment_page ? 'True' : 'False'),
    },
    {
      label: 'Category name',
      data: (d) => d.asset?.category
          ? d.asset.category.category_name
          : '-',
    },
    {
      label: '',
      data: (d) => {
        return (
          <div className="flex justify-evenly">
            <Link to={`/models/edit?id=${d.id}`}>
              <button size="small" rounded variant="secondary">
                Edit
              </button>
            </Link>
            <button
              size="small"
              rounded
              variant="secondary"
              className="ml-[20px] text-[red]"
              onClick={() => {
                onDelete(d.id)
              }}
            >
              Delete
            </button>
          </div>
        )
      },
    },
  ]

  const { data: apiData, loading } = useRequest(modelsRequest)

  const [data, setData] = useState()

  useEffect(() => {
    setData(apiData)
  }, [apiData])

  const filteredData = useMemo(() => {
    if (!data) return []
    if (!search.trim()) return data
    const lower = search.toLowerCase()
    return data.filter(
      (d) => d.asset?.asset_name?.toLowerCase().includes(lower) || d.high_res_model_path?.toLowerCase().includes(lower),
    )
  }, [data, search])

  async function onDelete(modelId) {
    // Implement the delete functionality here
    await deleteModel(modelId)
    toast.success('Model deleted successfully')
    setData((data) => data.filter((d) => d.id !== modelId))
  }
  const navigate = useNavigate()

  const actions = [
    {
      label: 'Create new model',
      action: () => {
        navigate({ to: `/models/create` })
      },
    },
  ]

  return (
    <ScreenLayout title="Manage 3D Models">
      {loading ? (
        <div>
          <Loader />
        </div>
      ) : (
        <div>
          <div className="flex justify-end items-center">
            <div className="w-[300px]">
              <Input
                label="Search by model name"
                placeholder="Search ..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>
          <DataTable title="Models" actions={actions} structure={table} data={filteredData} pagination />
        </div>
      )}
    </ScreenLayout>
  )
}

export default Manage3DModelsScreen
